<template>
  <div>
    <div @click="showPopup" style="width: 100%">
      <CommonInput
        v-model="currentValue"
        type="text"
        :placeholder="placeholder"
        :class="[$store.state.isMirroring && 'mirror']"
        theme="white"
        readonly
      >
        <img class="arrow" :class="[$store.state.isMirroring && 'mirror']" src="@/assets/back_new.png" alt="back" />
      </CommonInput>
    </div>
    <LinkAccountSelect
      v-model="show"
      :list="countries"
      :index-list="indexList"
      :on-select="selectItem"
      :onShow="(val) => (show = val)"
      show-text="countryName"
    />
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import CommonInput from '@/components/CommonInput.vue'
import Vue from 'vue'
import { IndexBar, IndexAnchor } from 'vant'
import LinkAccountSelect from '@/components/LinkAccount/Select'

Vue.use(IndexBar)
Vue.use(IndexAnchor)

export default {
  name: 'SelectCountry',
  components: {
    Tabbar,
    CommonInput,
    LinkAccountSelect
  },
  data() {
    return {
      currentValue: '',
      show: false,
      countries: [],
      indexList: []
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    placeholder: String
  },
  async created() {
    this.getCountryList()
  },
  methods: {
    getCountryList() {
      this.$http
        .get(window.serverPath + `/api/country/getNewAreaCodeList`)
        .then((res) => {
          const data = res.data
          if (data && data.code === '200') {
            const countryList = []
            const indexList = []
            res.data.data.forEach((item) => {
              if (item.popularFlag === 1) {
                indexList.push('#')
                countryList.push({
                  type: '#',
                  data: item.data
                })
              } else {
                indexList.push(item.countryType)
                countryList.push({
                  type: item.countryType,
                  data: item.data
                })
              }
            })
            this.countries = countryList
            this.indexList = indexList
          }
        })
        .catch(function (err) {
          console.log(err)
        })
    },
    showPopup() {
      this.show = true
    },
    onBack() {
      this.show = false
    },
    selectItem(value) {
      this.currentValue = value.countryName
      this.show = false
      this.$emit('change', value.countryNo)
    }
  }
}
</script>

<style scoped>
.select-country-wrapper {
  height: 0.4rem;
  width: 100%;
  font-size: 0.16rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.select_account_arrow {
  flex: none;
  box-sizing: border-box;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.select_account_arrow_img {
  width: 0.12rem;
  height: 0.12rem;
  transform: rotateY(180deg);
}

.select_account_arrow_img.mirror {
  transform: none;
}

.content_item_input::-webkit-input-placeholder {
  color: #aeaeae;
}

.arrow {
  width: 0.1rem;
  height: 0.1rem;
  transform: rotate(180deg);
}

.arrow.mirror {
  transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/components/SelectCountry.vue